module.exports = __webpack_public_path__ + "static/media/pishevoi_promyshlennosti.3d901bf7.pdf";